import React, { useState } from "react";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import BlockIcon from "@material-ui/icons/Block";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { confirmDialog } from 'primereact/confirmdialog';

import UserService from "../../services/UserService";
let userService = new UserService();

const ActionCell = ({ rowData, reload }) => {
  let [hideEmail, setHideEmail] = useState(false);

  const approveUserBrowser = () => {
    confirmDialog({
      message: `Are you sure you want to APPROVE ${rowData.browser_id}?`,
      header: 'Approve Browser',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        userService.approveUserBrowser(rowData.user_id, rowData.browser_id).then((result) => {
          reload();
        })
      }
    });
  };
  const blockUserBrowser = () => {
    confirmDialog({
      message: `Are you sure you want to Block ${rowData.browser_id}?`,
      header: 'Block Browser',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: () => {
        userService.blockUserBrowser(rowData.user_id, rowData.browser_id).then((result) => {
          reload();
        });
      }
    });
  };

  const resetUserBrowser = () => {
    confirmDialog({
      message: `Are you sure you want to Reset ${rowData.browser_id}?`,
      header: 'Reset Browser',
      icon: 'pi pi-info-circle',
      accept: () => {
        userService.resetUserBrowser(rowData.user_id, rowData.browser_id).then((result) => {
          console.log("Result:", result);
          reload();
        });
      }
    });
  };

  const resendEmail = () => {
    confirmDialog({
      message: `Are you sure you want to Resend Email?`,
      header: 'Resend Email',
      icon: 'pi pi-info-circle',
      accept: () => {
        userService.resendEmail(rowData.user_id, rowData.browser_id, rowData.properties, rowData.context).then((result) => {
          setHideEmail(true);
        }).catch(err => alert(err));
      }
    });
  };

  return (
    <React.Fragment>
    <span className="p-column-title">Actions</span>    
    <Tooltip title="Block Device">
      <IconButton aria-label="block" onClick={blockUserBrowser} style={{padding:2}}>
        <BlockIcon />
      </IconButton>
      </Tooltip>
      
    <Tooltip title="Reset Device">      
      <IconButton aria-label="reset"  onClick={resetUserBrowser} style={{padding:2}}>
        <AutorenewIcon />
      </IconButton>      
    </Tooltip>
    
    <Tooltip title="Approve Device">
      <IconButton aria-label="approve" onClick={approveUserBrowser} style={{padding:2}}>
        <VerifiedUserIcon />
      </IconButton>
    </Tooltip>
    {rowData.status==="challenge"&&!hideEmail&& <Tooltip title="Resend Email">
      <IconButton aria-label="approve" onClick={resendEmail} style={{padding:2}}>
        <MailOutlineIcon />
      </IconButton>
    </Tooltip>}
    </React.Fragment>
  );
};

export default ActionCell;
